import React from "react";
import { cn } from "../../lib/utils.js";

/* ---------------- Divider ----------------
   Polymorphic root (hr | div | span depending on orientation/label), so it
   carries rest-prop spread but intentionally does NOT forwardRef — there is no
   single stable element type to forward to. Documented carve-out from §14.5. */

export interface DividerProps extends React.HTMLAttributes<HTMLElement> {
  orientation?: "horizontal" | "vertical";
  label?: React.ReactNode;
}

export function Divider({
  orientation = "horizontal",
  label,
  className,
  ...rest
}: DividerProps) {
  if (orientation === "vertical") {
    return (
      <span
        role="separator"
        aria-orientation="vertical"
        className={cn("inline-block w-px self-stretch bg-pb-border", className)}
        {...rest}
      />
    );
  }
  if (label) {
    return (
      <div
        className={cn("flex items-center gap-3", className)}
        role="separator"
        {...rest}
      >
        <span className="flex-1 h-px bg-pb-border" />
        <span className="text-dense-2 uppercase tracking-wider text-pb-text-muted">
          {label}
        </span>
        <span className="flex-1 h-px bg-pb-border" />
      </div>
    );
  }
  return (
    <hr className={cn("border-0 h-px bg-pb-border", className)} {...rest} />
  );
}
